import { useEffect } from "react";
import business from "../../seo/business";

function setMetaTag(attr, key, content) {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLinkTag(rel, href) {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Dependency-free per-page SEO: sets <title>, meta description, canonical
 * link and Open Graph/Twitter tags on mount, and injects any JSON-LD
 * schema passed in (removed again on unmount so navigating between pages
 * doesn't accumulate duplicate <script> blocks).
 *
 * CRA renders every route from the same static index.html, so without
 * this every page would report the homepage as its canonical URL - this
 * corrects that per-route, for both real users and JS-rendering crawlers.
 */
export default function Seo({ title, description, path = "/", image, jsonLd }) {
  useEffect(() => {
    const url = `${business.siteUrl}${path}`;

    if (title) document.title = title;
    setMetaTag("name", "description", description);
    setMetaTag("property", "og:title", title);
    setMetaTag("property", "og:description", description);
    setMetaTag("property", "og:url", url);
    setMetaTag("property", "og:type", "website");
    setMetaTag("property", "og:image", image || business.logo);
    setMetaTag("name", "twitter:card", "summary_large_image");
    setMetaTag("name", "twitter:title", title);
    setMetaTag("name", "twitter:description", description);
    setMetaTag("name", "twitter:image", image || business.logo);
    setLinkTag("canonical", url);

    const scripts = [];
    const schemas = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];
    schemas.forEach((schema) => {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
      scripts.push(script);
    });

    return () => {
      scripts.forEach((script) => document.head.removeChild(script));
    };
  }, [title, description, path, image, jsonLd]);

  return null;
}
